export const RISKIFIED_SESSION_ID_COOKIE = "riskified-session-id";
export const IMPACT_REFERENCE_ID_COOKIE = "impact-reference-id";
